import React, {useState} from "react";
import {makeStyles} from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import * as yup from 'yup';
import {useFormik} from 'formik';
import axios from "axios";
import {Box, Snackbar} from "@material-ui/core";
import Link from "@material-ui/core/Link";

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(3)
    },
    submit: {
        margin: theme.spacing(3, 0, 2)
    }
}));

const formValidationSchema = yup.object({
    email: yup
    .string()
    .email('Inserisci un\'email valida')
    .required('Email richiesta'),
});

const ControlEmail = (props) => {
    const [sent, setSent] = useState(false);

    const formik = useFormik({
        initialValues: {
            email: '',

        },

        validationSchema: formValidationSchema,
        onSubmit: async (values) => {
            await handleChange();
        },

    });

    const handleChange = async (event) => {
        const data = {
            email: formik.values.email,
        }

        // (BERA): Invio Form QUI
        const response = await axios.get(`http://etpgaranzia.com:8080/garanzia/api/v1/auth/service/forgot-password/${data.email}`);
        if (response.status === 200) {
            setSent(true);
        }
        console.table(response);
    }

    const classes = useStyles();

    return (
        <form onSubmit={formik.handleSubmit}>
            <Container component="main" maxWidth="xs">
                <CssBaseline />
                <Container className={classes.paper}>
                    <Avatar className={classes.avatar}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Inserisci email di recupero
                    </Typography>
                    <Container className={classes.form}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    variant="outlined"
                                    required
                                    fullWidth
                                    type="text"
                                    id="email"
                                    label="Email"
                                    name="email"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.email}
                                    error={formik.touched.email && Boolean(formik.errors.email)}
                                    helperText={formik.touched.email && formik.errors.email}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                        </Grid>
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                        >
                            Conferma
                        </Button>
                        <Box sx={{textAlign: 'center'}}>
                            <Link href="#/login" variant="body2">
                                Login
                            </Link>
                        </Box>
                    </Container>
                </Container>
            </Container>
            <Snackbar
                open={sent}
                autoHideDuration={6000}
                message="Email inviata!"
            />
        </form>
    )
};
export default ControlEmail;